import { render, staticRenderFns } from "./col.vue?vue&type=template&id=2c0c18ae&scoped=true&"
import script from "./col.vue?vue&type=script&lang=js&"
export * from "./col.vue?vue&type=script&lang=js&"
import style0 from "./col.vue?vue&type=style&index=0&id=2c0c18ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c18ae",
  null
  
)

export default component.exports